(function ($) {
    $(document).ready(function () {
       extraServices();
    });

    function extraServices() {
        var wrap_container = $('.section.experiences .container');
        var wrap = $('.section.experiences .list');

        // refers to the carousel counter
        var $status = wrap_container.find('.pagingInfo');
        wrap_container.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
            var i = (currentSlide ? currentSlide : 0) + 1;
            $status.text(i + '/' + slick.slideCount);
        });
        // refers to the carousel counter

        if (wrap.length > 0 && is_phone) {
            wrap.each( function () {
                var single_wrap = $(this);
                single_wrap.on("init", function () {
                    lazyLoadInstance.update();
                });
                single_wrap.slick({
                    autoplay: false,
                    arrows: false,
                    dots: false,
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    rows: 0,
                    variableWidth: false,
                    centerMode: false,
                    adaptiveHeight: true,
                    rtl: $('html').attr('dir') === 'rtl',
                    responsive :[
                        {
                            breakpoint: 767,
                            settings: {
                                arrows:true,
                                variableWidth: true,
                                prevArrow: accor_arrow_prev,
                                nextArrow: accor_arrow_next,
                                centerPadding: '50px',
                                appendArrows: wrap_container.find('.pager_wrap'),
                            }
                        },

                    ]
                });
            })
        }
    }

})(jQuery);


